import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=5ce4cd95&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=5ce4cd95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4cd95",
  null
  
)

export default component.exports